import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'arrayIncludes',
  standalone: false,
})
export class ArrayIncludesPipe implements PipeTransform {
  transform(array: any, search: any): boolean {
    if (!array) {
      return false;
    }
    return array.includes(search);
  }
}
